import { useEffect, useState } from "react";

export function useTypewriter(text: string, active: boolean, speed = 24) {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue("");
    if (!active) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setValue(text);
      return;
    }

    let index = 0;
    const timer = window.setInterval(() => {
      index += 1;
      setValue(text.slice(0, index));
      if (index >= text.length) window.clearInterval(timer);
    }, speed);

    return () => window.clearInterval(timer);
  }, [active, speed, text]);

  return value;
}
